const TOOLTIP_CONST = {
  clinic_first_consultation:
    'For clinic\n' +
    'Your background and current concerns\n' +
    'Mental health history\n' +
    'Treatment goals\n' +
    'Establishing rapport and trust',
  clinic_virtual_consultation: 'virtual explanation for clinic',
  doctor_first_consultation:
    'For doctor\n' +
    'Taking your medical history\n' +
    'Discussing your symptoms or concerns\n' +
    'Physical examination if needed\n' +
    'Initial diagnosis or assessment\n' +
    'Treatment plan recommendations\n' +
    'Discussion of next steps',
  doctor_virtual_consultation: 'virtual explanation for doctor'
};

export default TOOLTIP_CONST;
